import { AddIcon, EmptyWalletImage } from '@approvalmax/ui';
import { Box, Button, Flex, Grid, Text } from '@approvalmax/ui/src/components';
import { useCallback } from 'react';
import { routingService } from 'services/routing';
import { useCreateKyc } from 'shared/data/walletsKyc/v1';
import { useCompanyIdBasedOnUrl } from 'shared/hooks';
import { getPath, Path } from 'urlBuilder';

import { messages } from './StartKyc.messages';

export const StartKyc = () => {
    const { companyId } = useCompanyIdBasedOnUrl();
    const { mutate, isLoading } = useCreateKyc({
        onSuccess: () => {
            routingService.push(getPath(Path.walletsKycWizard, companyId, 'companyInfo'));
        },
    });

    const handleClick = useCallback(() => {
        mutate({ params: { path: { organizationId: companyId } } });
    }, [companyId, mutate]);

    return (
        <Flex height='100%' justifyContent='center' alignItems='center'>
            <Box color='white100' radius='medium' spacing='40 32' width={480}>
                <Grid gap={24} justifyItems='center'>
                    <EmptyWalletImage />

                    <Text font='headline' fontSize='small' fontWeight='medium'>
                        {messages.youDontHaveWallets}
                    </Text>

                    <Text font='body' fontWeight='regular'>
                        {messages.inOrderToCreate}
                    </Text>

                    <Button
                        color='mint80'
                        size='large'
                        progress={isLoading}
                        startIcon={<AddIcon />}
                        onClick={handleClick}
                    >
                        {messages.start}
                    </Button>
                </Grid>
            </Box>
        </Flex>
    );
};

StartKyc.displayName = 'StartKyc';
